/** Labels for content hosts (the final hop). Rollout checks add hosts as they are observed. */
export const KNOWN_HOSTS: Readonly<Record<string, string>> = {
  'docs.google.com': 'Google Sheets',
  'sheets.googleapis.com': 'Google Sheets'
};

export function fetchedText(host: string, at: string, format: (iso: string) => string): string {
  const label = KNOWN_HOSTS[host.toLowerCase()];
  return `By ReportPad from ${label ? `${label} (${host})` : host}, ${format(at)}`;
}
